export default __webpack_public_path__ + "static/media/carrosel05.c3000926.png";